import {
  AppNotification,
  NotificationType,
} from '../../../../components/notification/Notification'
import { useDeleteDebounce } from '../../../../utils/useDeleteDebounce'
import { IChooseItems } from '../../../../components/mainContent/TableAllDishes'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useArchiveMultipleGuestTypeMutation } from '../../../../core/api/GuestTypeApi'

interface UseDeleteGuestTypeResponse {
  deletePopup: boolean
  onDeletePopupHandler: () => void
  onDeleteHandler: () => void
  closeDeletePopup: () => void
}

export const useDeleteGuestType = (
  chooseItems: IChooseItems | null,
  setChooseItems: React.Dispatch<React.SetStateAction<IChooseItems | null>>,
): UseDeleteGuestTypeResponse => {
  const [deletePopup, setDeletePopup] = useState(false)
  const [archiveMultipleGuestType] = useArchiveMultipleGuestTypeMutation()
  const { t } = useTranslation()

  const deleteGuestTypeHandler = async () => {
    if (!!chooseItems) {
      archiveMultipleGuestType({
        data: Object.keys(
          Object.fromEntries(
            Object.entries(chooseItems).filter((e) => e.includes(true)),
          ),
        ).map((item) => Number(item)),
      })
        .unwrap()
        .then(() => {
          AppNotification({
            msg: t('Выбранные типы гостей успешно удалены!'),
            type: NotificationType.success,
          })
          setChooseItems(null)
        })
    }
  }

  const [onDeleteHandler] = useDeleteDebounce({
    fn: deleteGuestTypeHandler,
    extraText: t(
      'Выбранные вами типы гостей будут удалены на сервере и на всех станциях!',
    ),
  })

  const closeDeletePopup = () => setDeletePopup(false)
  const openDeletePopup = () => setDeletePopup(true)

  return {
    deletePopup,
    onDeletePopupHandler:
      process.env.REACT_APP_TYPE_SERVER === 'MainServer'
        ? openDeletePopup
        : onDeleteHandler,
    onDeleteHandler,
    closeDeletePopup,
  }
}
